var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "drop-shadow-sides", attrs: { id: "total" } },
    [
      _c("table", [
        _c("tr", [
          _c("td", { staticClass: "label-column" }, [_vm._v("Subtotal")]),
          _c("td", { staticClass: "value-column" }, [
            _vm._v(_vm._s(_vm._f("toCurrency")(_vm.session.check.subTotal))),
          ]),
        ]),
        _vm.gratuities > 0
          ? _c("tr", [
              _c("td", { staticClass: "label-column" }, [_vm._v("Gratuities")]),
              _c("td", { staticClass: "value-column" }, [
                _vm._v(_vm._s(_vm._f("toCurrency")(_vm.gratuities))),
              ]),
            ])
          : _vm._e(),
        _c("tr", [
          _c("td", { staticClass: "label-column" }, [_vm._v("Tax Total")]),
          _c("td", { staticClass: "value-column" }, [
            _vm._v(_vm._s(_vm._f("toCurrency")(_vm.taxTotal))),
          ]),
        ]),
        Math.abs(_vm.session.check.taxExempt) > 0
          ? _c("tr", [
              _c("td", { staticClass: "label-column bolder adjustment" }, [
                _vm._v("Tax Exempt"),
              ]),
              _c("td", { staticClass: "value-column bolder adjustment" }, [
                _vm._v(
                  "(" +
                    _vm._s(
                      _vm._f("toCurrency")(
                        Math.abs(_vm.session.check.taxExempt)
                      )
                    ) +
                    ")"
                ),
              ]),
            ])
          : _vm._e(),
        _c("tr", [
          _c("td", { staticClass: "label-column bolder" }, [_vm._v("Total")]),
          _c("td", { staticClass: "value-column bolder" }, [
            _vm._v(_vm._s(_vm._f("toCurrency")(_vm.total))),
          ]),
        ]),
        _vm.isTipVisible
          ? _c("tr", [
              _c("td", { staticClass: "label-column bolder" }, [_vm._v("Tip")]),
              _c("td", { staticClass: "value-column bolder" }, [
                _vm._v(_vm._s(_vm._f("toCurrency")(_vm.tip))),
              ]),
            ])
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }